import { render } from "./RegisterLitterView.vue?vue&type=template&id=dccccd12&scoped=true"
import script from "./RegisterLitterView.vue?vue&type=script&lang=js"
export * from "./RegisterLitterView.vue?vue&type=script&lang=js"

import "./RegisterLitterView.vue?vue&type=style&index=0&id=dccccd12&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccccd12"]])

export default __exports__